import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {ModalController, NavController, Platform} from '@ionic/angular';
import {ActivatedRoute, Router} from '@angular/router';
import {environment} from '../../../../../environments/environment';
import {Roles} from '../../../../_model';
import {StorageService} from '../../../../_services/storage.service';
import {ReadMoreComponent} from './read-more/read-more.component';
import {CommonService} from '../../../../_services/common.service';

@Component({
  selector: 'app-invisible-city',
  templateUrl: './invisible-city.component.html',
  styleUrls: ['./invisible-city.component.scss'],
})
export class InvisibleCityComponent implements OnInit {

  domElement: any;
  projectType = 'ap';
  darkProjectTypeImage = '';
  projectTypeImage = '';

  constructor(public translate: TranslateService,
              private platform: Platform,
              private navController: NavController,
              private activatedRoute: ActivatedRoute,
              private storageService: StorageService,
              private commonService: CommonService,
              public modalController: ModalController,
              private router: Router) {
  }


  get roles() {
    return Roles;
  }

  ngOnInit() {
    this.domElement = window.document.querySelector('ion-app') as HTMLElement;
    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.projectType = params.get('project');
      [this.projectType, this.projectTypeImage, this.darkProjectTypeImage] = this.commonService.getProjectLogo(this.projectType);
    });
  }

  signIn(role: Roles) {
    const userObj = {
      role
    };
    this.storageService.set(environment.userObj, userObj);

    if (role === Roles.guest) {
      this.router.navigate(['/map']);
    } else {
      this.router.navigate(['./user/auth/sign-in', this.projectType]);
    }
  }

  navigateToAboutUs() {
    this.router.navigate(['./about-us']);
  }

  scan() {
    this.router.navigate(['./kitchen']);
  }

  async readMore() {
    const modal = await this.modalController.create({
      component: ReadMoreComponent,
      componentProps: {
        projectType: this.projectType
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true
    });
    return await modal.present();
  }

  createAccount() {
    localStorage.setItem('projectType', this.projectType);
    this.router.navigate(['./user/auth/sign-up']);
  }
}
